import Vue from 'vue'
 // 手机号中间四位加密
Vue.filter('phoneFormat',function phoneFormat(phone) { 
    if(!phone) return phone;
    if(String(phone) != phone) return phone;
    phone = String(phone);
    var reg=/(\d{3})\d{4}(\d{4})/;
    return phone.replace(reg, "$1****$2");
} );


// WEBPACK FOOTER //
// ./src/filters/phoneFormat.js